export { default } from './ArtistAddInitialRecordingCredits';
